import asFormikField from './asFormikField';

const asFormField = asFormikField;
export default asFormField;
